/**
 * VIEW FEED ARTICLES ENTRY POINT
 *
 * The view feed articles page will display all the articles in a feed
 *
 * @version 0.1
 */

import React from 'react';
import { hashHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';

import headerActions from './../../reusable/Header/Header.actions';

import utils from './../../utils/utilities';

import ViewArticleWithNavigation from '../../reusable/PreviewArticle/ViewArticleWithNavigation';

/**
 * This page uses a config to load it's state which will contain
 * {
 *      url
 *      countUrl
 *      urlParams
 *      verb
 *      backRoute
 *      ttl
 *      injectEntity
 *      store
 *      headerKey
 *      hideTitle
 *      embeddedResultList
 *      internalStore
 * }
 *
 * Path params will provide articleId and articleIndex
 *
 */

class ViewArticlePage extends React.Component {

    constructor(props) {
        super(props);
        let config = JSON.parse(decodeURIComponent(utils.getQueryParam('config')));
        // TODO: we sould create a componentWillReceiveProps,
        // to update the state further and check child component behavior
        this.state = {
            config: config
        };
        this.moveToArticle = this.moveToArticle.bind(this);
    }

    componentWillMount() {
        if (this.state.config.headerKey === 'getStartedDashboardEntityProfile') {
            headerActions.updateHeaderContent(
                <FormattedMessage id='HeaderFooterNav_SubMenu_UIText_subMenu.entityAllArticlesFromDays'
                                  values={{
                                      entityTitle: this.state.config.ttl,
                                      daysNumber:  this.state.config.urlParams.noOfDays
                                  }} />,
                'viewingnewsarticlestips-field?lbu=US&locale=en_US&audience=all'
            );
        } else {
            headerActions.updateHeader(this.state.config.headerKey);
        }
    }

    moveToArticle(articleId, index) {
        let location = window.location.href.substr(window.location.href.indexOf('#/') + 2);
        let config = window.location.href.substr(window.location.href.indexOf('?'));
        let pathArray = location.split('/');
        pathArray[1] = articleId;
        pathArray[2] = index;
        let newLocation = pathArray.join("/") + config;
        hashHistory.push(newLocation);
    }

    render() {
        let articleId = parseInt(this.props.params.articleId, 10);
        let articleIndex = parseInt(this.props.params.articleIndex, 10);
        return (
            <ViewArticleWithNavigation
                articleId={articleId}
                articleIndex={articleIndex}
                backRoute={this.state.config.backRoute}
                injectEntity={this.state.config.injectEntity}
                title={this.state.config.ttl}
                verb={this.state.config.verb}
                url={this.state.config.url}
                countUrl={this.state.config.countUrl}
                urlParams={this.state.config.urlParams}
                hideTitle={this.state.config.hideTitle}
                articleCount={this.state.config.articleCount}
                embeddedResultList={this.state.config.embeddedResultList}
                internalStore={this.state.config.internalStore}
                moveToArticle={this.moveToArticle}
            />
        );
    }

}
export default ViewArticlePage;


// WEBPACK FOOTER //
// ./src/scripts/pages/ViewArticlePage/ViewArticlePage.jsx